module.exports = __webpack_public_path__ + "b744c4ef9869bc04aa62409b1a161592.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-james.png
// module id = 235
// module chunks = 30